import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';

const StatCard = ({ icon: Icon, label, value, trend, color = 'blue' }) => {
  const colorClasses = {
    blue: 'from-cobalt-500 to-cobalt-600',
    green: 'from-accent-teal to-accent-emerald',
    purple: 'from-accent-purple to-cobalt-500',
    orange: 'from-accent-amber to-accent-pink',
    red: 'from-red-500 to-pink-600',
  };

  const iconBgClasses = {
    blue: 'bg-apple-sky-blue',
    green: 'bg-gradient-to-br from-emerald-50 to-teal-100',
    purple: 'bg-gradient-to-br from-purple-50 to-indigo-100',
    orange: 'bg-gradient-to-br from-amber-50 to-orange-100',
    red: 'bg-gradient-to-br from-red-50 to-pink-100',
  };

  const iconColorClasses = {
    blue: 'text-cobalt-500',
    green: 'text-emerald-600',
    purple: 'text-purple-600',
    orange: 'text-amber-600',
    red: 'text-red-600',
  };

  return (
    <Card className="relative overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-0 bg-white">
      <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${colorClasses[color]}`} />
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className={`p-2.5 rounded-xl ${iconBgClasses[color]} shadow-sm`}>
            <Icon className={`w-5 h-5 ${iconColorClasses[color]}`} />
          </div>
          {trend && (
            <div className={`flex items-center px-2 py-1 rounded-full text-xs font-semibold ${
              trend.direction === 'up' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
            }`}>
              {trend.direction === 'up' ? (
                <TrendingUp className="w-3 h-3 mr-1" />
              ) : (
                <TrendingDown className="w-3 h-3 mr-1" />
              )}
              <span>{trend.value}%</span>
            </div>
          )}
        </div>
        <div>
          <p className="text-xs font-medium text-apple-aluminum uppercase tracking-wider mb-1">{label}</p>
          <p className="text-2xl font-bold text-apple-blue-black">{value}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
